import { Grid, Button } from "@material-ui/core"
import { useState } from "react"
import PickerMod from "../../../global/PickersMod"
import { useDispatch } from "react-redux"
import { obtenerReservasAuthBusquedaAction } from "../../../ducks/reservasAuthDuck"
import { FormatoFecha } from "../../../utils/FormatFecha"
import BackDrop from "../../../global/BackDrop"
const FiltradoReservasAutorizadas = () => {
    const [fechaIncio, setFechaInicio] = useState(new Date())
    const [fechaFinal, setFechaFinal] = useState(new Date())
    const [load, setLoad] = useState(false)
    const dispatch = useDispatch()
    const handleFiltro = () => {
        setLoad(true)
        dispatch(obtenerReservasAuthBusquedaAction({ FechaInicio: FormatoFecha({ date: fechaIncio, formato: "MMddyyyy" }), FechaFin: FormatoFecha({ date: fechaFinal, formato: "MMddyyyy" })})).then(Response => {
            setLoad(false)
        })
    }
    return (
        <div>
            <Grid
                style={{ margin: "2% 0" }}
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center">
                <Grid item xs={1}>
                    <Button onClick={handleFiltro} color="primary">Filtrar</Button>
                </Grid>
                <Grid item xs={3}>
                    <div style={{ paddingRight: "35px" }}>
                        <PickerMod
                            id="FechaInicio"
                            label="Fecha Inicio"
                            selectedDate={fechaIncio}
                            setSelectedDate={setFechaInicio}
                            disablePast={false}
                            disableFuture={true}
                        />
                    </div>
                </Grid>
                <Grid item xs={3}>
                    <div style={{ paddingRight: "35px" }}>
                        <PickerMod
                            id="FechaFinal"
                            label="Fecha Final"
                            selectedDate={fechaFinal}
                            setSelectedDate={setFechaFinal}
                            disablePast={false}
                            disableFuture={true}
                        />
                    </div>
                </Grid>
            </Grid>
            <BackDrop open={load} />
        </div>
    )
}
export default FiltradoReservasAutorizadas